module.exports = __webpack_public_path__ + "static/media/SF-8-A (1).f37af606.mp3";